import { BranchLimitsHolder } from "@tlc/ls2pac/components/BranchLimits";
import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { LibraryThing } from "./widget/LibraryThingWidget";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";
import { LanguageHolder } from "@tlc/ls2pac/components/Language";
import { SupportedFunctionalityHolder } from "@tlc/ls2pac/components/SupportedFunctionality";
import { StationLocationHolder } from "@tlc/ls2pac/components/StationLocation";
import { GlobalConfigHolder } from "@tlc/ls2pac/components/GlobalConfig";

/**
 * @deprecated
*/
export const ApplicationData = (function ( $ ) {

	var locationConfiguration;

	LocationConfigurationHolder.subscribe((data) => {
		locationConfiguration = data.locationConfiguration;
	});

	GlobalConfigHolder.fetchGlobalConfig().then((data) => {
		myData.globalConfiguration = data;
	});

	SupportedFunctionalityHolder.get().then((supportedFunctionality) => myData.supportedFunctionality = supportedFunctionality);

	StationLocationHolder.get().then((data) => {
		myData.currentBranch = data;
		if(data) {
			myData.currentBranchId = data.identifier;
		}
	});

	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onLogoutResponse, function ( event ) {
		ApplicationData.branchLimitsUtil.setLimitedBranches( [] );
		//TLCLogger.log("appData:currentUser:", myData.currentUser, ApplicationData.getCurrentUser());
	} );

	LanguageHolder.subscribe((data) => {
		myData.language = data.dictionary;
	});

	//The cat ate my gymsuit

	var currResultsView;
	var currentBackEvent;

	var myData = {
		getCurrentUser:                function () {
			return myData.currentUser;
		},
		getUserDefaultPickupBranch:    function () {
			var branch = null;
			if( myData.currentUser !== undefined && myData.currentUser !== null ) {
				//use defaultRequestPickupBranch first, if thats not set use issuing
				if( myData.currentUser.defaultRequestPickupBranch ) {
					branch = myData.currentUser.defaultRequestPickupBranch;
				}
				else if( myData.currentUser.issuingBranch ) {
					branch = myData.currentUser.issuingBranch;
				}
			}
			return branch;
		},
		getBranchToUseForAvailability: function ( ignoreUsersBranch ) {
			var branch = null;

			//is station location is set use it
			if( myData.currentBranchId ) {
				branch = myData.currentBranchId;
				return branch;
			}
			//is there only one branch?
			var oneBranch = ApplicationData.branchLimitsUtil.getBranchIfThereIsOnlyOne();
			if( oneBranch != null ) {
				return oneBranch;
			}
			//but
			if( ApplicationData.locationConfiguration.useUsersBranchForAvailability() == false || ignoreUsersBranch ) {
				return null;
			}
			//and finally
			return ApplicationData.getUserDefaultPickupBranch();
		},
		setCurrentBackEvent:           function ( backEvent ) {
			currentBackEvent = backEvent;
		},
		getSearchTypeHash:             function ( type ) {
			return myData.SearchTypeHash[type];
		},
		locationConfiguration:         {
			showBranchLimitControl:                   function () {
				var onlyOneBranch = ApplicationData.branchLimitsUtil.getBranchIfThereIsOnlyOne();
				return !this.isConfigLimitedToOneBranch() && !onlyOneBranch;
			},
			showAudienceControl:                      function () {
				return locationConfiguration.pacSettings.displaySettings.displayAudienceCharacteristicsFilter;
			},
			isConfigLimitedToOneBranch:               function () {
				if( locationConfiguration.filterBranches ) {
					var locations = $.grep( locationConfiguration.filterBranches, function ( location ) {
						return location.shared == false;
					} );
					return (locations.length == 1);
				}
				return false;
			},
			isLimitedToOneBranch:                     function () {
				return (ApplicationData.branchLimitsUtil.getLimitedBranches().length == 1);
			},
			isLocationKnown:                          function () {
				if( ApplicationData.getBranchToUseForAvailability() || ApplicationData.locationConfiguration.isLimitedToOneBranch() ) {
					return true;
				}
				return false;
			},
			getLibraryName:                           function () {
				return locationConfiguration.libraryName;
			},
			isLDAPEnabled:                            function () {
				if( !myData.globalConfiguration.ldapEnabled ) {
					return false; // CAS is no longer available/enabled
				}
				return myData.globalConfiguration.ldapEnabled;
			},
			isVirtualShelfEnabled:                    function () {
				return locationConfiguration.pacSettings.displaySettings.displayVirtualShelf;
			},
			isDisplayCopiesFirst:                     function () {
				return locationConfiguration.pacSettings.displaySettings.displayCopiesFirst;
			},
			getAllowHolds:                            function () {
				return {
					item:          locationConfiguration.pacSettings.userActionSettings.allowItemLevelHolds,
					title:         locationConfiguration.pacSettings.userActionSettings.allowTitleLevelHolds,
					onShelf:       locationConfiguration.pacSettings.userActionSettings.allowOnShelfHolds,
					restrictTitle: locationConfiguration.pacSettings.userActionSettings.restrictTitleLevelHolds
				};
			},
			getAllowBookings:                         function () {
				return locationConfiguration.pacSettings.bookingsSettings.allowBookings;
			},
			getAllowRenewals:                         function () {
				return locationConfiguration.pacSettings.userActionSettings.allowRenewals;
			},
			getBookingsBranchIdentifier:              function () {
				return locationConfiguration.pacSettings.bookingsSettings.bookingsBranchIdentifier;
			},
			getShowMap:                               function () {
				// TODO Fix this once maps are implemented
				//TLCLogger.log("############ WARNING ###########", "locationConfiguration.pacSettings.displaySettings.showMapView is forced to false because its not implemented");
				return false;//locationConfiguration.pacSettings.displaySettings.showMapView;
			},
			getUseDummyJackets:                       function () {
				return locationConfiguration.pacSettings.displaySettings.useDummyJackets;
			},
			allowTagging:                             function () {
				return locationConfiguration.pacSettings.userActionSettings.allowTagging;
			},
			getAdditionalLinkBehavior:                function () {
				if( locationConfiguration.pacSettings.displaySettings.openLinksInNewTab ) {
					return "_blank";
				}
				return "";
			},
			getAdditionalLinks:                       function () {
				var additionalLinks = [];
				if( locationConfiguration.pacSettings.additionalLink1 !== null &&
					locationConfiguration.pacSettings.additionalLink1.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink1.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink1.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink2 !== null &&
					locationConfiguration.pacSettings.additionalLink2.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink2.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink2.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink3 !== null &&
					locationConfiguration.pacSettings.additionalLink3.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink3.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink3.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink4 !== null &&
					locationConfiguration.pacSettings.additionalLink4.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink4.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink4.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink5 !== null &&
					locationConfiguration.pacSettings.additionalLink5.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink5.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink5.additionalLinkURL
					} );
				}
				return additionalLinks;
			},
			isEcommerceEnabled:                       function () {
				return locationConfiguration.pacSettings.ecommerceEnabled;
			},
			getCarlXWebEcommerceEnabled:              function () {
				return myData.globalConfiguration.carlXWebEcommerceSettings.enabled;
			},
			getCarlXWebEcommerceUrl:                  function () {
				return myData.globalConfiguration.carlXWebEcommerceSettings.url;
			},
			getPersonalInformationIsHidden:           function () {
				return myData.globalConfiguration.globalSettings.hidePersonalInformation;
				//ApplicationData.globalConfiguration.hidePersonalInformation
			},
			getUseAlternateTimeoutPage:               function () {
				return locationConfiguration.pacSettings.useAlternateTimeoutPage;
			},
			getAlternateTimeoutPageUrl:               function () {
				return locationConfiguration.pacSettings.alternateTimeoutPageUrl;

			},
			getMainLogoUrl:                           function () {
				return locationConfiguration.pacSettings.displaySettings.mainPageLogoImageId;
			},
			setMainLogoUrl:                           function ( imageId ) {
				locationConfiguration.pacSettings.displaySettings.mainPageLogoImageId = imageId;
			},
			isOverDriveEnabled:                       function () {
				return locationConfiguration.pacSettings.useOverDrive;
			},
			isBakerAndTaylorEnabled:                  function () {
				return locationConfiguration.pacSettings.useBakerAndTaylor;
			},
			isTeachingBooksEnabled:                   function () {
				return locationConfiguration.pacSettings.useTeachingBooks;
			},
			isMackinEnabled:                  function () {
				return locationConfiguration.pacSettings.useMackin;
			},
			useThirdPartyEResourceAvailability:       function () {
				return ApplicationData.locationConfiguration.isOverDriveEnabled()
					|| ApplicationData.locationConfiguration.isBakerAndTaylorEnabled()
					|| ApplicationData.locationConfiguration.isMackinEnabled();
			},
			isDisplaySelectPickupLocation:            function () {
				return locationConfiguration.pacSettings.displaySettings.displaySelectPickupLocation;
			},
			areReadingLevelsEnabled:                  function () {
				return ApplicationData.locationConfiguration.isLexileEnabled()
					|| ApplicationData.locationConfiguration.isAcceleratedReaderEnabled();
			},
			displayReadingLevelKidsSearchResults:     function () {
				return locationConfiguration.pacSettings.kidsSettings.displaySettings.displayReadingLevelInKidsSearchResults;
			},
			isLexileEnabled:                          function () {
				return locationConfiguration.pacSettings.lexileEnabled;
			},
			isAcceleratedReaderEnabled:               function () {
				return locationConfiguration.pacSettings.acceleratedReaderEnabled;
			},
			isQuizNumberEnabled:                      function () {
				return locationConfiguration.pacSettings.acceleratedReaderShowQuizNumber;
			},
			getGoogleAnalyticsSettings:               function () {
				return locationConfiguration.pacSettings.googleAnalyticsSettings;
			},
			isStationLocationSet:                     function () {
				return (myData.currentBranchId != undefined);
			},
			isDownloadNowOverrideSet:                 function () {
				return locationConfiguration.pacSettings.overrideDownloadNowStationLocation;
			},
			useUsersBranchForAvailability:            function () {
				var useUsersBranchForAvailability = locationConfiguration.pacSettings.userActionSettings.useUsersBranchForAvailability;

				return (useUsersBranchForAvailability === undefined) ? true : useUsersBranchForAvailability;
			},
			kidsLandingPage:                          function () {
				return locationConfiguration.pacSettings.kidsSettings.landingPage;
			},
			isKidsOverrideDownloadNowStationLocation: function () {
				return locationConfiguration.pacSettings.kidsSettings.overrideDownloadNowStationLocation;
			},
			isKidsEnableEResourceAvailability:        function () {
				return locationConfiguration.pacSettings.kidsSettings.enableEResourceAvailability;
			},
			isKidsEnableEResourceHoldsCheckouts:      function () {
				return locationConfiguration.pacSettings.kidsSettings.enableEResourceAvailability &&
					locationConfiguration.pacSettings.kidsSettings.enableEResourceHoldsCheckouts;
			},
			isADFSEnabled:                            function () {
				return myData.globalConfiguration.adfsEnabled;
			},
			useADFSRedirect:                            function () {
				return myData.globalConfiguration.adfsSettings.useRedirect;
			},
			getADFSTimeoutUrl:                        function () {
				return myData.globalConfiguration.adfsSettings.timeoutUrl;
			},
			getADFSLogoutUrl:                         function () {
				return myData.globalConfiguration.adfsSettings.logoutUrl;
			}
		},
		branchLimitsUtil:              {
			getLimitsWithoutHidden:        function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.hidden === false);
			},
			setLimitedBranches:            function ( limitedBranchIds ) {
				BranchLimitsHolder.setSelectedBranchIds(limitedBranchIds);
			},
			getIsLimiting:                 function () {
				const {isConfigLimited} = myData.branchLimits;
				return isConfigLimited || BranchLimitsHolder.getSelectedBranchIds().length;
			},
			/**
			 *
			 * @return {Array.<string>}
			 */
			getLimitedBranches:            function () {
				const limits = BranchLimitsHolder.getSelectedBranchIds();

				if(limits.length > 0) {
					return limits;
				}

				const {filterBranches = []} = locationConfiguration;

				return filterBranches.filter((branch) => branch.shared == false).map((branch) => branch.identifier);
			},
			getBranchNameById:             function ( id ) {
				const {branchLimits} = myData.branchLimits;
				const match = branchLimits.find((branch) => branch.identifier === id.toString());
				if(match){
					return match.displayName;
				}
				return "";
			},
			getCurrentBranchIfNotLimited:  function ( ignoreUsersBranch ) {
				const branchToUseForAvailability = ApplicationData.getBranchToUseForAvailability( ignoreUsersBranch );
				if(!branchToUseForAvailability) {
					return null;
				}

				const limitedBranches = ApplicationData.branchLimitsUtil.getLimitedBranches();

				if(limitedBranches.length === 0) {
					return branchToUseForAvailability;
				}

				return limitedBranches.includes(branchToUseForAvailability) ? branchToUseForAvailability : null;
			},
			getDisplayInPickupLocationIds: function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.displayInPickupLocation).map((branch) => branch.identifier);
			},
			getDisplayInCopiesIds:         function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.displayInCopies).map((branch) => branch.identifier);
			},
			getBranchIfThereIsOnlyOne:     function () {
				const {branchLimits} = myData.branchLimits;

				const visibleBranchIds = branchLimits
					.filter((branch) => branch.hidden === false && branch.displayInCopies)
					.map((branch) => branch.identifier);
				if(visibleBranchIds.length === 1) {
					return visibleBranchIds[0];
				}
				return null;
			}
		}
	};

	AccountHolder.subscribe(({user}) => {
		myData.currentUser = user;
	});
	BranchLimitsHolder.fetchBranchLimits().then((event) => {
		myData.branchLimits = event;
	});

	myData.SearchTypeHash = {};
	myData.SearchTypeHash["default"] = {
		type:   "default",
		prefix: ""
	};
	myData.SearchTypeHash["authorsuggestion"] = {
		type:   "facets.author",
		prefix: "facets.author:"
	};
	myData.SearchTypeHash["author"] = {
		type:   "author",
		prefix: "au:"
	};
	myData.SearchTypeHash["title"] = {
		type:   "title",
		prefix: "ti:"
	};
	myData.SearchTypeHash["subject"] = {
		type:   "subject",
		prefix: "su:"
	};
	myData.SearchTypeHash["seriestitle"] = {
		type:   "seriestitle",
		prefix: "se:"
	};
	myData.SearchTypeHash["isbn"] = {
		type:   "isbn",
		prefix: "isbn:"
	};
	myData.SearchTypeHash["tag"] = {
		type:   "tag",
		prefix: "tag:"
	};
	myData.SearchTypeHash["rss"] = {
		type:   "rss",
		prefix: "rss:"
	};
	myData.SearchTypeHash["callNumber"] = {
		type:   "CallNumber",
		prefix: "cn:"
	};

	return myData;

})( jQuery );
